import { router, usePage } from "@inertiajs/react"
import { useEffect, useState } from "react"
import { toast } from "sonner"

import type { Flash } from "@/types"

const emptyFlash = {}

export const useFlash = () => {
  const page = usePage<{ flash: Flash }>()
  const { flash } = page.props
  const isLoginPage = page.component === "users/sessions/new"
  const [currentFlash, setCurrentFlash] = useState<Flash>(emptyFlash)

  useEffect(() => {
    setCurrentFlash(flash ?? emptyFlash)
  }, [flash])

  router.on("start", () => {
    setCurrentFlash(emptyFlash)
  })

  useEffect(() => {
    if (isLoginPage) {
      return
    }
    if (currentFlash.alert) {
      toast.error(currentFlash.alert)
    }
    if (currentFlash?.notice) {
      toast.success(currentFlash.notice)
    }
  }, [currentFlash, isLoginPage])
}
